export const getFileNameWithEllipsis = (fileName, maxLength = 100) => {
  if (!fileName) {
    return '-';
  }

  if (fileName.length <= maxLength) {
    return fileName;
  }
  const halfLength = Math.floor((maxLength - 3) / 2);
  return `${fileName.slice(0, halfLength)}...${fileName.slice(-halfLength)}`;
};
